import { useMemo } from 'react';

import { useCurrentSite } from '@hotjar/site';
import { upsell as openUpsellModal } from '@hotjar/webapp/domains/revenue/upsell';
import { noop } from '@hotjar/webapp/lib/function';

import type { KnownReferrer } from '../features/Billing/PlanComparisonModal/types';

interface SubscriptionFunctions {
  upsell: (referrer: KnownReferrer) => void;
}

/**
 * Wraps the upsell function into a hook, which will always pass along the current site to the function.
 *
 * Usage:
 * const { upsell } = useSubscription();
 * upsell('your-upsell-referrer')
 */
export function useSubscription(): SubscriptionFunctions {
  const { data: currentSite } = useCurrentSite();

  return useMemo(() => {
    return {
      upsell: (referrer) => {
        if (!currentSite) {
          throw new Error('useSubscription.upsell(): Site not loaded yet.');
        }

        openUpsellModal({
          site: currentSite,
          referrer,
        }).then(noop, noop);
      },
    };
  }, [currentSite]);
}
